<template>
	<div class="rounded-6 mb-3 border bold-shadow p-3 position-relative">
    <p class="mb-0 badge-available body-3-3 text-white px-2" v-if="$isProductAllowDelivery(data)">Available for deliviery</p>
		<div class="row no-gutters">
			<div class="align-self-center" :class="getMerchant.is_preview_only ? 'col-12' : 'col-8'">
				<div class="pr-3">
					<p class="mb-0 body-2-1">{{data.name}}</p>
					<p 
						v-if="is_decrease_promo" 
						class="mb-0 text-line-through body-3 d-inline-block align-middle mr-1">
						{{$formatCurrency(promotion_price)}}
					</p>
					<p 
						class="mb-0 body-2-4 text-orange mr-1"
						:class="{
							'd-inline-block align-middle': is_decrease_promo
						}"
						>
						{{$formatCurrency(final_price)}}
					</p>
					<span
						v-if="is_decrease_promo" 
						class="mb-0 font-bold text-green bg-green-light px-1 rounded-4 d-inline-block align-middle text-12">-{{Math.floor(data.price.promotion_pct)}}%</span>

				</div>
			</div>
			<div v-if="!getMerchant.is_preview_only" class="col-4 align-self-center">
				<button
					v-if="qty_cart == 0"
					@click="changeQty('plus')" 
					class="ga-btn-primary-outline w-100">
					Select
				</button>
				<div v-else class="w-100">
					<div class="row no-gutters">
						<div class="col-4 align-self-center">
							<div class="pos-order-qty bg-orange" @click="changeQty('minus')">
								<svg width="12" height="2" viewBox="0 0 12 2" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M12 1.71429H0V0H12V1.71429Z" fill="white" />
								</svg>
							</div>
						</div>
						<div class="col-4 align-self-center text-center">
							<p class="mb-0 font-lato text-14">{{ qty_cart  }}</p>
						</div>
						<div class="col-4 align-self-center">
							<div class="pos-order-qty bg-orange ml-auto" @click="changeQty('plus')">
								<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M12 6.85714H6.85714V12H5.14286V6.85714H0V5.14286H5.14286V0H6.85714V5.14286H12V6.85714Z" fill="white" />
								</svg>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import {mapGetters} from 'vuex'
	import {calculateFinalPriceConcierge} from '@/utils/index.js'

	export default{
		props: ['data','product_cart_index'],
		data(){
			return{
				qty_cart: 0
			}
		},
		computed:{
			...mapGetters(['getRestaurantOrder', 'getMerchant']),
			variant_in_cart(){
				let return_data = -1
				if(this.product_cart_index != -1){
					return_data = this.getRestaurantOrder.cart[this.product_cart_index].variant.findIndex(x=>x.data.product_ga_pos_id == this.data.product_ga_pos_id)
				}
				return return_data
			},
			final_price(){
        return calculateFinalPriceConcierge(this.data.price)
      },
      promotion_price(){
        if(this.data.price.promotion_amount == 0){
          return 0
        }else{
          return this.data.price.tax_service_calculation_type == 'INCLUDE' ? this.data.price.price_sell_base : this.data.price.price_sell
        }
      },
      is_decrease_promo(){
        if(this.data.price.promotion_amount == 0){
          return false
        }else{
          return this.data.price.promotion_type == 'INCREASE' ? false : true
        }
      },
		},
		watch:{
			qty_cart(){
				this.$emit('updateQty',{
					data: this.data,
					qty: this.qty_cart 
				})
			}
		},
		mounted(){
			if(this.variant_in_cart != -1) {
				this.qty_cart = this.getRestaurantOrder.cart[this.product_cart_index].variant[this.variant_in_cart].qty
			}
		},
		methods:{
			changeQty(type){
				if(type == 'plus'){
					this.qty_cart++
				}else{
					if(this.qty_cart > 0){
						this.qty_cart--
					}
				}
			}
		}
	}
</script>
<style>
  .pos-order-qty {
    cursor: pointer;
    width: 30px;
    height: 30px;
    display: grid;
    place-items: center;
    text-align: center;
    border-radius: 6px;
  }
  .badge-available{
    position: absolute;
    top: 0px;
    right: 0px;
    background-color: #000000b5;
    border-radius: 0px 0px 0px 3px;
    display:table;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/restaurant-v2/menuItemVariant.vue